export default __webpack_public_path__ + "4cbae37729caf3f10a3469f9c1ccbe7a.jpeg";